import { Controller, UseFormReturn } from 'react-hook-form';
import { SelectDropdown } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { BaseSelectDropdown } from './BaseSelectDropdown';

export const SelectDropdownFormElement = ({ form, component }: { form: UseFormReturn; component: SelectDropdown }) => {
  const fieldName = encodeFieldKey(component);

  return (
    <Controller
      control={form.control}
      name={fieldName}
      render={({ field, fieldState }) => (
        <BaseSelectDropdown
          id={fieldName}
          label={component.label}
          options={component.options.map((o) => ({
            value: o.value.toString(),
            label: o.label,
            sublabel: o.sublabel ?? undefined,
          }))}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          selectProps={{
            ...field,
            value: (field.value as string) ?? (component.value as string) ?? '',
          }}
        />
      )}
    />
  );
};
